import { render, staticRenderFns } from "./CustomChart.vue?vue&type=template&id=68b2cb17&scoped=true"
import script from "./CustomChart.vue?vue&type=script&lang=js"
export * from "./CustomChart.vue?vue&type=script&lang=js"
import style0 from "./CustomChart.vue?vue&type=style&index=0&id=68b2cb17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2cb17",
  null
  
)

export default component.exports